import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { StyledRadio, Label, styledSystemKeys } from "./radioFilterButton.styles.js";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RadioFilterButton = function RadioFilterButton(props) {
  var id = props.id,
    label = props.label,
    checked = props.checked,
    onChange = props.onChange,
    _onKeyDown = props.onKeyDown,
    name = props.name,
    disabled = props.disabled,
    className = props.className;
  var radio = /*#__PURE__*/_jsx(StyledRadio, {
    id: id,
    type: "radio",
    checked: checked,
    name: name,
    disabled: disabled,
    onChange: onChange,
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown && _onKeyDown(e);
    }
  });
  return /*#__PURE__*/_jsxs(Label, _objectSpread(_objectSpread({
    htmlFor: id,
    disabled: disabled,
    checked: checked,
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [radio, label]
  }));
};
RadioFilterButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onKeyDown: PropTypes.func,
  checked: PropTypes.oneOf([true, false]),
  disabled: PropTypes.bool,
  className: PropTypes.string
};
export default RadioFilterButton;